import { CreateActionParams } from '../actions';
import { bookingsBookingsFormLoad } from '@wix/bi-logger-wixboost-ugc/v2';
import { FormStatus } from '../../../../types/form-state';

export type InitializeWidget = () => void;

export function createInitializeWidgetAction({
  getControllerState,
  internalActions: { calculatePaymentDetails },
  context: { biLogger },
}: CreateActionParams): InitializeWidget {
  return async () => {
    const [state, setState] = getControllerState();
    const { isBookingsOnEcom } = state;
    if (isBookingsOnEcom) {
      await calculatePaymentDetails({});
    }

    biLogger?.report(
      bookingsBookingsFormLoad({
        formId: state.service.formSchema.formId,
      }),
    );
    setState({
      status: FormStatus.IDLE,
    });
  };
}
